export const calculateNodePosition = (view, target, handler) => {
    var _a;
    const state = view.state;
    const { from } = state.selection;
    const node = view.domAtPos(from).node;
    if (!(node instanceof HTMLElement)) {
        throw new Error();
    }
    const selectedNodeRect = node.getBoundingClientRect();
    const targetNodeRect = target.getBoundingClientRect();
    const parentNodeRect = (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    if (!parentNodeRect) {
        throw new Error();
    }
    const [top, left] = handler(selectedNodeRect, targetNodeRect, parentNodeRect);
    target.style.top = top + 'px';
    target.style.left = left + 'px';
};
export const calculateTextPosition = (view, target, handler) => {
    var _a;
    const state = view.state;
    const { from, to } = state.selection;
    const start = view.coordsAtPos(from);
    const end = view.coordsAtPos(to);
    const targetNodeRect = target.getBoundingClientRect();
    const parentNodeRect = (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    if (!parentNodeRect) {
        throw new Error();
    }
    const [top, left] = handler(start, end, targetNodeRect, parentNodeRect);
    target.style.top = top + 'px';
    target.style.left = left + 'px';
};
//# sourceMappingURL=index.js.map